import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import ChangePasswordModal from "../../../../containers/ChangePasswordModal";
// import EditIcon from "../../../../assets/svg/EditIcon";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BackIcon from "../../../../assets/svg/BackIcon";
import ProfileImg from "../../../../assets/images/profile-img.webp";
// import Footer from "../../../../containers/Footer";
import deposit1st from "../../../../assets/images/promotion/deposit1st.jpg";
import deposit2nd from "../../../../assets/images/promotion/deposit2nd.jpg";
import Header from "../../../../containers/Header";

import Offer1 from "../../../../assets/images/banner/banner1.png"
import Offer2 from "../../../../assets/images/banner/banner2.png"
import Offer3 from "../../../../assets/images/banner/banner3.png"
import Offer6 from "../../../../assets/images/banner/banner6.png"

const Promotion = ({ isAuth }) => {
  const { user } = useSelector((state) => state.auth);
  const { bankDetails } = useSelector((state) => state.app);
  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main" id="profile_page">
        <Container>
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Promotion</h2>
            <a className="back-link" href="/">
              Back <BackIcon />
            </a>
          </div>


          <div className="PromotionSection">
            <ul>
              <li>
                <a href="/offer1">
                  <img src={Offer1} alt="offer" />
                  <div className="KnowMore">
                    <p>10% 1st deposit bonus upto INR 2,000</p>
                    <span>Know More</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/offer2">
                  <img src={Offer2} alt="offer" />
                  <div className="KnowMore">
                    <p>5% 2nd deposit bonus upto INR 2,000</p>
                    <span>Know More</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/offer3">
                  <img src={Offer3} alt="offer" />
                  <div className="KnowMore">
                    <p>100% Lossback Bonus on 1st deposit upto INR 25,000</p>
                    <span>Know More</span>
                  </div>
                </a>
              </li>
               <li>
                <a href="/offer6">
                  <img src={Offer6} alt="offer" />
                  <div className="KnowMore">
                    <p>600% Bonus on 1st deposit upto INR 3,600</p>
                    <span>Know More</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
         
        </Container>
      </main>
    </>
  );
};

export default Promotion;
